import React, { useState } from 'react';
import api from '../api';

function Admin() {
    const [inviteToken, setInviteToken] = useState('');

    async function createInvite() {
        try {
            const res = await api.post('/admin/create-invite');
            setInviteToken(res.data.token);
            alert(`New Invite Token: ${res.data.token}`);
        } catch (err) {
            alert('Failed to create invite token.');
        }
    }

    return (
        <div className="admin">
            <h1>⚙️ Admin Panel</h1>
            <button onClick={createInvite}>Generate Invite Token</button>
            {inviteToken && <p>New Token: {inviteToken}</p>}
        </div>
    );
}

export default Admin;
